import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import ZainiqSignupPageDisplay from "./SignupPage.styled";
import "./ZainiqSignupPage.scss";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import { getPlayitApiV2Base } from "../../../helpers/playitApiConfig";

const zainiqApiBase = `${getPlayitApiV2Base()}/zainiq/gamezroid`;

function ZainiqSignupPage({ t, i18n }) {
  const currentLang = (i18n.language || "ar").startsWith("en") ? "en" : "ar";

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  };
  const [activeData, setActiveData] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);

  const [showverif, setShowverif] = useState(false);
  const [verifyCode, setVerifyCode] = useState('');
  const [errorMesg, setErrorMesg] = useState(false);
  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [errorresverify, seterrorresverify] = useState("");

  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [signupPlan, setSignupPlan] = useState("d");
  const [otpid, setotpid] = useState("");
  const [showLoading, setshowLoading] = useState(false);



  const history = useHistory();
  const [alert, setAlert] = useState(false);


  const plans = [
    {
      plan: "d",
      name: "Daily"
    },
    {
      plan: "w",
      name: "Weekly"
    }
  ];

  useEffect(() => {
       getScript();

    const urlsearch = window.location.search;
    if (urlsearch !== "") {
     //console.log("tracker")
      setAgencyData(urlsearch);
    }
  }, []);


   function getScript(){
    const url = `${zainiqApiBase}/get-script?te=signup`;
      axios.get(url)
        .then(res => {
          if (res.data.success === true) {
            const addScript = document.createElement('script');
          
           addScript.innerHTML = res.data.script;
           document.head.appendChild(addScript);
           var event = new Event('DCBProtectRun');
           document.dispatchEvent(event);
             localStorage.setItem('ti', res.data.ti);     
           localStorage.setItem('ts', res.data.ts); 
          }
         

        })
        .catch(function (error) {
          setErrorMesg(true)
          setShowverif(false)
        })
        .finally(function () {
         //console.log('complete');
        });
    } 
    // save tracker
    const tracker = async (GMSISDN) => {
      var datag = {};
      if (localStorage.getItem('tracker')) {
        var op_id = 'DBkuaTgj1c';
  
  
        datag = {
          key: 'parameter',
          company: localStorage.getItem("trackerCompany"),
          value: localStorage.getItem('tracker'),
          identifierKey: 'id',
          identifierValue: op_id,
          phoneNum: GMSISDN
        };
       //console.log(datag)
  
      }
      await saveTracker(datag);
  
    }
  const Subscribe = async e => {
    e.preventDefault();
    if (activeData) {
      var phon_n = activeData.toString();
      var url = "";

      url = `${zainiqApiBase}/sendpin?msisdn=${phon_n}`;
      setshowLoading(true);
      axios.get(url)
        .then(res => {
          if (res.data.status === true) {
           
            if (res.data.otpid) {
              setotpid(res.data.otpid)
            }
            setShowverif(true)
          }
          else {
            if (res.data.msg != null) {
              setErrorMesgSubscribe(res.data.msg);
              setErrorMesg(true);

            }
            else {
              setErrorMesgSubscribe(t("register.SUBSCRIBE_ERROR"));
              setErrorMesg(true);


            }
           // setShowverif(true)


          }
          setshowLoading(false);

        })
        .catch(function (error) {
          setErrorMesg(true)
          setShowverif(false)
        })
        .finally(function () {
         //console.log('complete');
        });


    }
  };


  const verify = async e => {
    e.preventDefault();
    if (verifyCode) {
      var phon_n = activeData;
      setshowLoading(true);

      axios.get(`${zainiqApiBase}/verify?msisdn=${phon_n}&pin=${verifyCode}&plan=w&ti=${localStorage.getItem('ti')}&ts=${localStorage.getItem('ts')}`)
        .then(res => {
          if (res.data.status == true) {
            setVerfiErrorMesg(false);
            //tracker(phon_n);
            if (res.data.user_id) {
              tracker(phon_n);
              setLoginData(res.data.user_id, res.data.token, res.data.user_name, res.data.photo, res.data.operator_id, res.data.user_email, res.data.msisdn);
              // window.location.href = "/";
            }
           //  window.location.href = "/";
           history.push("/catch-zainiqgamezroid")
          } else {
            if (res.data.msg != null) {
              seterrorresverify(res.data.msg);;
              setVerfiErrorMesg(true);

            }
            else {
              // setErrorMesgSubscribe(t("register.SUBSCRIBE_ERROR"));
              seterrorresverify(t("register.VERIFY_ERROR"));
              setVerfiErrorMesg(true);


            }
            // setVerfiErrorMesg(true);
            // seterrorresverify(res.data.msg);
          }
          setshowLoading(false);

        })
        .catch(function (error) {
         //console.log(error);
          // setVerfiErrorMesg(true);
          // seterrorresverify(res.data.msg);

        })
        .finally(function () {

         //console.log('complete');
        });
    }
  };

  const plansOptions = plans.map((c, k) => {
    return (
      <option key={`plan-${k}`} value={c.plan}>
        {c.name}
      </option>
    );
  });




  return (
    <ZainiqSignupPageDisplay>
      {alert && (
        <FloatingAlert type={"danger"}>
          In order to signup please turn your mobile data.
        </FloatingAlert>
      )}

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {verfiErrorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorresverify}</Trans>
        </FloatingAlert>
      ) : null}

      <div className="zainiq-page">
        <header className="zainiq-header">
          <button
            type="button"
            className="zainiq-lang-btn active"
            onClick={() =>
              changeLanguage(currentLang === "en" ? "ar" : "en")
            }
          >
            {currentLang === "en" ? "العربية" : "English"}
          </button>
          <Link to="/" className="zainiq-logo-link" aria-label="Gamezroid">
            <div className="zainiq-logo gamezoneLogo" />
          </Link>
        </header>

        <main className="zainiq-main">
          {!showverif ? (
            <>
              <div className="zainiq-dots" aria-hidden="true">
                <span />
                <span />
                <span />
              </div>
              <h1 className="zainiq-hero-title">
                <Trans>zainiq_hero_title</Trans>
              </h1>
              <p className="zainiq-hero-sub">
                <Trans>zainiq_hero_sub1</Trans>
              </p>
             

              <div className="zainiq-phone-wrap">
                <input
                  type="tel"
                  inputMode="numeric"
                  className="zainiq-phone-input"
                  placeholder={t("Enter_your_phone_number")}
                  value={activeData}
                  disabled={checkPhone === true}
                  onChange={(e) =>
                    setActiveData(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>

              <div className="zainiq-chevrons" aria-hidden="true">
                ›››
              </div>

              <button
                id="signup"
                type="button"
                className="zainiq-cta-btn"
                disabled={!activeData}
                onClick={(e) => Subscribe(e)}
              >
                <Trans>zainiq_play_btn</Trans>
              </button>
              <p className="zainiq-ready-text">
                <Trans>Your content is ready!</Trans>
              </p>
            </>
          ) : (
            <div className="zainiq-verify-section">
              <p>
                <Trans>verifycodeJawwalGameszorid</Trans>
              </p>
              <input
                type="tel"
                inputMode="numeric"
                className="input"
                value={verifyCode}
                placeholder={t("Enter_verifycode")}
                onChange={(e) =>
                  setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))
                }
              />
              <button
                type="button"
                className="zainiq-cta-btn"
                disabled={!verifyCode}
                onClick={(e) => verify(e)}
              >
                {t("Verify")}
              </button>
            </div>
          )}
        </main>

        <footer className="zainiq-wave-footer">
          <div className="zainiq-terms">
            <h3>
              <Trans>terms_and_conditions</Trans>
            </h3>
            <p>
              <Trans>zainiq-condtion</Trans>
            </p>
          </div>
        </footer>

        {showLoading ? (
          <div className="load">
            <div className="spinerC">
              <div className="spinner" />
            </div>
          </div>
        ) : null}
      </div>
    </ZainiqSignupPageDisplay>
  );
}
export default withTranslation()(ZainiqSignupPage)
